import styled from "styled-components";
import { Button, TextField, Typography } from "@mui/material";
import { theme } from "../../utils/globalStyles/colors";
import SendIcon from "@mui/icons-material/Send";

export const TransferCard = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Label = styled(Typography)`
  font-weight: 700 !important;
  color: ${theme.colors.base};
  font-size: 14px !important;
`;

export const Input = styled(TextField)`
  width: 100%;

  & .MuiInputBase-root {
    background-color: #f9f9f9;
    border-radius: 8px;
  }

  & input {
    font-size: 16px;
    padding: 14px;
    color: #333333;
  }

  & input::placeholder {
    color: #999999;
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${theme.colors.base};
    border-width: 2px;
  }
`;

export const ButtonMui = styled(Button)`
  background-color: ${theme.colors.base} !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  height: 52px !important;
  width: 100% !important;
  font-weight: bold !important;
  font-size: 16px !important;
  text-transform: none !important;
  margin-top: 8px !important;

  &:hover {
    opacity: 0.9;
  }

  &.Mui-disabled {
    background-color: #e0e0e0 !important;
    color: #999999 !important;
  }
`;

export const SendIconMui = styled(SendIcon)`
  margin-left: 8px;
`;
